// store/index.ts
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import projectReducer from './dailylog/Reducer';
import { ProjectState } from './dailylog/Types';
import dailyLogsReducer from './dailylog/dailyLogsSlice';
import userReducer from './subscription/Reducer';

export interface RootState {
  project: ProjectState;
  dailyLogs: any;
  user:any;
}

const rootReducer = combineReducers({
  project: projectReducer,
  dailyLogs: dailyLogsReducer,
  user: userReducer,
  // other reducers...
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
